export default "__VITE_ASSET__f97a1357__"